import React from 'react';
import {Modal} from "react-bootstrap";
import TranslationService from "../../service/TranslationService";
import {
    INCLUDED_CHANNELS_IN_TARIFF
} from "../../language-content/keys";

const tvChannelsModal = (props) => {
    return (
        <Modal show={props.package} size={"lg"} onHide={() => props.selectDisplayTvPackage(null)}
               className={"channels-modal vip-modal"}>
            <Modal.Header className="border-bottom-0 mt-3">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => props.selectDisplayTvPackage(null)}>
                    <img
                        src={process.env.REACT_APP_IMAGES_URL + '/A1_close_icon_32.png'}/>
                </button>
                <Modal.Title><h5
                    className="serif-bold mb-3 pr-4">  {TranslationService.translate(INCLUDED_CHANNELS_IN_TARIFF, props.lang)} </h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="scrollable-wrapper">
                    <div className="scrollable-content">
                <div
                    className="row row-cols-2 row-cols-md-3 row-cols-lg-4 d-flex flex-fill justify-content-start pb-3 ">


                    {props.package && props.package.channels.map(c => {
                        return (
                            <div
                                className="col align-self-center flex-column d-flex justify-content-center align-items-center mt-4">
                                <img src={c.channelLogoPath} alt=""
                                     className="img-fluid"/> <span class="h5 d-block text-center mt-2"> {displayChannelName(c)} </span>
                            </div>
                        )
                    })}

                            </div>
                        </div>

                </div>
            </Modal.Body>

        </Modal>
    );

    function displayChannelName(channel) {
        if (props.lang === 'en_US')
            return channel.nameEN;
        else if (props.lang === 'sq_AL')
            return channel.nameAL;
        else return channel.name;
    }
};

export default tvChannelsModal;
